import { createRouter, FileRoutesByPath, Router } from '@tanstack/react-router';
import type { ComponentType, SVGProps } from 'react';

import type { TFunction } from '@mint-lib/i18n';
import type { RouterContext } from '@mint-lib/routing-context';
import type { Guard } from '@mint-lib/routing-guards';

import { NotFound } from './components/NotFound.jsx';
import { context } from './context/router-context.js';
// @ts-ignore TS6307 Does not include this file
import { routeTree } from './routeTree.gen.js';

export * from '@tanstack/react-router';

export const routerContext = context;
export type MintRouter = Router<typeof routeTree, 'preserve', boolean>;

// Create a new router instance
const routerInstance = createRouter({
  routeTree,
  context,
  defaultNotFoundComponent: NotFound,
  trailingSlash: 'preserve',
});

export { routerInstance };

export type AllRoutesByPath = keyof FileRoutesByPath;
export type CommandFlagEnv = '@mint/arm' | '@myn/secured';

// Arguments passed to `commandMeta` by the command palette (@myn/command)
export type CommandMetaArgs = {
  t: TFunction<'@mint/routing'>;
  /** Runs a guard; flags are read from `flagsEnv` (default '@mint/arm') */
  check: (guard: Guard, flagsEnv?: CommandFlagEnv) => boolean;
};

// Describes how a route appears in the command palette (@myn/command)
export type CommandMeta = {
  title: string;
  keywords?: string[];
  // Icon component, e.g. from @mint-lib/icons; the palette falls back to ArrowRight
  icon?: ComponentType<SVGProps<SVGSVGElement>>;
};

// Return undefined to hide the route from the command palette
export type CommandMetaFn = (args: CommandMetaArgs) => CommandMeta | undefined;

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof routerInstance;
  }
  interface StaticDataRouteOption {
    commandMeta?: CommandMetaFn;
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface RouteContext extends RouterContext {}
}
